/**
 * 구독 & 결제 FAQ 데이터
 * 토스페이먼츠 연동 및 기간제 구독 시스템 기반
 * 전자상거래 등에서의 소비자보호에 관한 법률 준수
 */

export const paymentFaq = [
  {
    id: 'payment-001',
    category: 'payment',
    question: 'Pro 구독의 장점은 무엇인가요?',
    answer: `
      <div class="pro-benefits">
        <h4>PRO에서 달라지는 점</h4>
        <ul>
          <li><strong>AI 모델</strong> - GPT-6.1, Claude Sonnet 5.5, Gemini 3.1 Pro</li>
          <li><strong>생기부</strong> - 한 번에 30명, 엑셀로 150명까지</li>
          <li><strong>파일 첨부</strong> - PDF, HWP, 이미지, Excel</li>
          <li><strong>참고 자료함</strong> - 텍스트·파일 합쳐 500개</li>
          <li><strong>디자인형</strong> - 디자인 PPT(40장까지), 디자인 학습지</li>
        </ul>

        <h4>요금</h4>
        <ul>
          <li><strong>1개월</strong>: 24,000원</li>
          <li><strong>3개월</strong>: 60,000원 (월 20,000원)</li>
          <li><strong>6개월</strong>: 110,000원 (월 18,333원)</li>
          <li><strong>12개월</strong>: 200,000원 (월 16,667원)</li>
        </ul>
        <p>부가세 포함이에요. 기간이 끝나면 자동 결제되지 않아요.</p>

        <div class="comparison-table">
          <h4>무료와 PRO</h4>
          <table style="width: 100%; border-collapse: collapse;">
            <tr style="background-color: #f8fafc;">
              <th style="padding: 8px; border: 1px solid #e2e8f0;">기능</th>
              <th style="padding: 8px; border: 1px solid #e2e8f0;">FREE</th>
              <th style="padding: 8px; border: 1px solid #e2e8f0;">PRO</th>
            </tr>
            <tr>
              <td style="padding: 8px; border: 1px solid #e2e8f0;">AI 모델</td>
              <td style="padding: 8px; border: 1px solid #e2e8f0;">기본 모델</td>
              <td style="padding: 8px; border: 1px solid #e2e8f0;">GPT-6.1 · Claude Sonnet 5.5 · Gemini 3.1 Pro</td>
            </tr>
            <tr>
              <td style="padding: 8px; border: 1px solid #e2e8f0;">생기부 생성</td>
              <td style="padding: 8px; border: 1px solid #e2e8f0;">한 번에 3명</td>
              <td style="padding: 8px; border: 1px solid #e2e8f0;">30명 · 엑셀 150명</td>
            </tr>
            <tr>
              <td style="padding: 8px; border: 1px solid #e2e8f0;">파일 첨부</td>
              <td style="padding: 8px; border: 1px solid #e2e8f0;">불가</td>
              <td style="padding: 8px; border: 1px solid #e2e8f0;">가능</td>
            </tr>
            <tr>
              <td style="padding: 8px; border: 1px solid #e2e8f0;">참고 자료함</td>
              <td style="padding: 8px; border: 1px solid #e2e8f0;">텍스트 3개</td>
              <td style="padding: 8px; border: 1px solid #e2e8f0;">500개 (파일 포함)</td>
            </tr>
            <tr>
              <td style="padding: 8px; border: 1px solid #e2e8f0;">엑셀 일괄 처리</td>
              <td style="padding: 8px; border: 1px solid #e2e8f0;">불가</td>
              <td style="padding: 8px; border: 1px solid #e2e8f0;">생기부·검사·채점</td>
            </tr>
            <tr>
              <td style="padding: 8px; border: 1px solid #e2e8f0;">PPT / 학습지</td>
              <td style="padding: 8px; border: 1px solid #e2e8f0;">글자형 (PPT 8장까지)</td>
              <td style="padding: 8px; border: 1px solid #e2e8f0;">디자인형까지 (PPT 40장까지)</td>
            </tr>
          </table>
        </div>

        <p>자세한 비교는 <a href="/pricing">요금제</a>에서 볼 수 있어요.</p>
      </div>
    `,
    tags: ['Pro 구독', '요금제', '혜택', '무료 vs 유료', '구독 비교'],
    relatedFaqs: ['payment-002', 'payment-003', 'getting-started-003'],
    lastUpdated: '2026-10-15',
    seoTitle: '왓퀴즈 PRO 혜택과 요금',
    seoDescription: 'PRO 모델, 파일 첨부, 참고 자료함 500개, 월 16,667원부터의 기간제 요금을 안내합니다.'
  },

  {
    id: 'payment-002',
    category: 'payment',
    question: '결제는 어떻게 하나요? 안전한가요?',
    answer: `
      <h3>토스페이먼츠 결제</h3>
      <p>왓퀴즈는 토스페이먼츠로 결제해요. 카드 번호는 왓퀴즈에 저장하지 않아요.</p>

      <h4>지금 가능한 결제</h4>
      <ul>
        <li>국내 신용카드, 체크카드</li>
      </ul>
      <p>계좌이체와 휴대폰 결제는 준비 중이에요. 해외 발행 카드는 안 돼요.</p>

      <h4>결제 순서</h4>
      <ol>
        <li><a href="/pricing">요금제</a>에서 기간을 골라요.</li>
        <li>카드 정보를 입력해요.</li>
        <li>끝나면 PRO가 바로 켜져요.</li>
      </ol>

      <h4>잘 안 될 때</h4>
      <ul>
        <li>카드사 인증 창이 막히면 팝업을 허용해요.</li>
        <li>한도가 충분한지 확인해요.</li>
        <li>결제는 됐는데 FREE로 보이면 이용권 확인 FAQ를 봐요.</li>
        <li>계속되면 채널톡 또는 angel@plactical.com으로 문의해요.</li>
      </ul>
    `,
    tags: ['결제 방법', '토스페이먼츠', '보안', '안전', '신용카드', '간편결제'],
    relatedFaqs: ['payment-001', 'payment-007', 'payment-005'],
    lastUpdated: '2026-09-09',
    seoTitle: '왓퀴즈 결제 방법',
    seoDescription: '토스페이먼츠 카드 결제 순서와 결제가 안 될 때 확인할 점을 안내합니다.'
  },

  {
    id: 'payment-003',
    category: 'payment',
    question: '기간제 결제는 어떻게 되나요? 자동으로 연장되나요?',
    answer: `
      <div class="period-payment-info">
        <h4>기간제 결제</h4>
        <ul>
          <li><strong>한 번만 결제</strong>: 선택한 기간(1/3/6/12개월)만 이용해요</li>
          <li><strong>자동 갱신 없음</strong>: 기간이 끝나면 무료로 바뀌어요</li>
          <li><strong>만료 알림</strong>: 만료 1주일 전과 3일 전에 메일로 알려 드려요</li>
          <li><strong>연장</strong>: 만료 전에 원하는 기간으로 다시 결제하면 돼요</li>
        </ul>

        <h4>환불 정책 (전자상거래법 제17조 준수, 2026.4.25 단순화 개정)</h4>
        <div class="refund-policy">
          <h5>결제 후 7일 이내 — 100% 자동 환불</h5>
          <ul>
            <li><strong>사용 이력과 무관하게</strong>: 결제 후 7일 이내라면 이미 사용하셨더라도 100% 전액 환불</li>
            <li><strong>마이페이지에서 즉시 처리</strong>: 마이페이지 → 구독 관리 → [환불 요청] 버튼 클릭 → 자동 환불</li>
            <li><strong>위약금 없음</strong>: 별도 위약금이나 차감 없이 결제 금액 그대로 환불</li>
            <li><strong>환불 처리 기간</strong>: 신청 후 3영업일 이내 (지연 시 「전자상거래법」 제18조에 따른 연 20% 지연이자)</li>
          </ul>

          <h5>결제 후 7일 경과 — 자동 환불 불가, 별도 문의</h5>
          <ul>
            <li><strong>자동 환불 불가</strong>: 7일이 지나면 마이페이지에서 자동 환불은 불가합니다.</li>
            <li><strong>법적 근거</strong>: AI 서비스는 이용 시 즉시 외부 AI API 비용이 발생하는 디지털 콘텐츠로, 「전자상거래법」 제17조 제2항 제5호에 따라 청약철회가 제한될 수 있습니다.</li>
            <li><strong>예외 사유</strong>: 회사 귀책사유, 서비스 장애, 명백한 결제 오류, 시스템 문제 등 특별한 사정이 있는 경우 angel@plactical.com 으로 문의하시면 사안별로 검토합니다.</li>
            <li><strong>환불 제외</strong>: 이용약관 위반, 허위정보 제공, 매크로·계정 공유, 단기 집중 이용 후 환불 등 오남용으로 인정되는 경우</li>
          </ul>

          <h5>환불 방법</h5>
          <ul>
            <li><strong>신용카드 결제</strong>: 카드사 승인 취소 (3-5영업일)</li>
            <li><strong>계좌이체/가상계좌</strong>: 고객 계좌로 직접 입금 (3영업일)</li>
            <li><strong>간편결제</strong>: 각 결제사 정책에 따라 환불 (3-7영업일)</li>
          </ul>
        </div>

        <h5>환불 문의 및 신청</h5>
        <ul>
          <li><strong>마이페이지 자동 환불</strong>: 7일 이내라면 마이페이지 → 구독 관리에서 즉시 처리</li>
          <li><strong>이메일</strong>: angel@plactical.com (7일 경과 후 또는 특별 사정 발생 시)</li>
          <li><strong>제목</strong>: [환불 신청] 가입 이메일 주소</li>
          <li><strong>필요 정보</strong>: 가입 이메일, 결제일, 환불 사유</li>
          <li><strong>처리 시간</strong>: 영업일 기준 24시간 이내 답변</li>
        </ul>

        <div class="legal-notice">
          <h4>소비자 권리 보장 (관련 법령)</h4>
          <ul>
            <li><strong>청약철회권</strong>: 「전자상거래법」 제17조 제1항 — 7일 이내 100% 환불 보장</li>
            <li><strong>디지털 콘텐츠 청약철회 제한</strong>: 「전자상거래법」 제17조 제2항 제5호 — 7일 초과 시 자동 환불 제한 가능</li>
            <li><strong>환급의무</strong>: 「전자상거래법」 제18조 제2항 — 3영업일 이내 환급</li>
            <li><strong>지연이자</strong>: 「전자상거래법」 제18조 제3항 — 환불 지연 시 연 20% 지연이자</li>
            <li><strong>약관 명시 의무</strong>: 「약관규제법」 제3조 — 환불 정책 변경 시 사전 명시·설명</li>
            <li><strong>분쟁조정</strong>: 한국소비자원 소비자분쟁조정위원회 (국번없이 1372)</li>
          </ul>
          <p style="margin-top: 12px; padding: 10px; background: #f0fff4; border-left: 4px solid #22c55e; font-size: 14px;">
            <strong>2026.4.25 단순화 개정 안내</strong>: 기존의 사용량 기반 차감 환불·건당 단가표·위약금 10%는 폐지되고, "7일 이내 100% 자동 환불 / 7일 경과 별도 문의"로 단순화되었습니다. 자세한 내용은 <a href="/help/notice/refund-policy-update-2026-04">공지사항</a> 또는 <a href="/refund-policy">환불 정책 전문</a>을 참고해 주세요.
          </p>
        </div>
      </div>
    `,
    priority: 'high',
    tags: ['기간제결제', '일회성결제', '연장', '환불정책', '청약철회권'],
    seoTitle: '왓퀴즈 기간제 결제 시스템 및 환불 정책 - 전자상거래법 준수',
    seoDescription: '왓퀴즈 PRO 기간제 결제 시스템, 서비스 연장 방법, 환불 정책 (7일 이내 100% 자동 환불) 안내. 자동갱신 없는 투명한 결제 시스템.'
  },



  {
    id: 'payment-005',
    category: 'payment',
    question: '영수증·거래명세서 같은 증빙 서류는 어디서 받나요?',
    answer: `
      <h3>증빙 서류 받기</h3>
      <p>결제한 뒤 언제든 내 계정에서 서류 7종을 받을 수 있어요. 결제 직후에는 거래명세서와 납품확인서를 메일로도 보내드려요.</p>

      <h4>받는 방법</h4>
      <ol>
        <li>마이페이지 → 구독 관리 → 결제 내역</li>
        <li>결제 옆 <strong>증빙 서류</strong>를 눌러요</li>
        <li><strong>서류 한 번에 받기</strong>로 ZIP 파일 하나에 모두 받아요</li>
      </ol>

      <h4>받을 수 있는 서류</h4>
      <ul>
        <li>결제 영수증 (카드 매출전표 또는 현금영수증)</li>
        <li>거래명세서 · 납품확인서(주문확인서 겸용) · 견적서</li>
        <li>사업자등록증 · 통장사본 · 4대보험 완납증명서</li>
      </ul>

      <h4>학교 예산·복지포인트로 제출할 때</h4>
      <ul>
        <li>보통 <strong>결제 영수증 + 거래명세서</strong>를 함께 내요.</li>
        <li>학교 예산이라면 증빙 서류 화면에서 받는 분을 <strong>학교 이름</strong>으로 바꾼 뒤 받아요.</li>
        <li><strong>메일로 보내기</strong>로 행정실 이메일에 바로 보낼 수 있어요.</li>
        <li>학교 예산은 보통 학교 카드로 결제해야 해요. 개인 카드로 결제했다면 행정실에 먼저 확인해주세요.</li>
        <li>복지포인트 인정 범위는 기관마다 달라요. 제출 전에 담당자에게 확인해주세요.</li>
      </ul>

      <h4>잘 안 될 때</h4>
      <ul>
        <li>쿠폰·초대 혜택으로 받은 이용권과 전액 환불한 결제는 증빙 서류가 없어요.</li>
        <li>서류가 안 열리면 결제일과 가입 이메일을 적어 angel@plactical.com으로 문의해주세요.</li>
      </ul>
    `,
    tags: ['영수증', '거래명세서', '납품확인서', '주문확인서', '견적서', '증빙서류', '복지포인트', '학교 예산', '행정실'],
    relatedFaqs: ['payment-006', 'payment-002', 'payment-007'],
    lastUpdated: '2026-10-01',
    seoTitle: '왓퀴즈 증빙 서류 받기 - 영수증·거래명세서·납품확인서',
    seoDescription: '왓퀴즈 PRO 결제 후 영수증, 거래명세서, 납품확인서, 견적서, 사업자등록증 등 증빙 서류 7종을 내 계정에서 받는 방법과 학교 예산·복지포인트 제출 안내.'
  },

  {
    id: 'payment-006',
    category: 'payment',
    question: '세금계산서 발급이 가능한가요?',
    answer: `
      <div class="tax-invoice-info">
        <h4>카드·현금영수증 결제는 세금계산서가 나오지 않아요</h4>
        <p>신용·체크카드로 결제했거나 현금영수증을 받은 결제는 세금계산서를 따로 발행할 수 없어요(부가가치세법). 카드 매출전표나 현금영수증이 세금계산서를 대신하는 공식 증빙이에요.</p>
        <p>행정실에는 <strong>결제 영수증 + 거래명세서</strong>를 함께 내면 돼요. 마이페이지 → 구독 관리 → 결제 내역의 <strong>증빙 서류</strong>에서 받을 수 있어요.</p>

        <h4>세금계산서가 꼭 필요하다면</h4>
        <ul>
          <li>학교·단체 구매(S2B 학교장터 포함)는 세금계산서를 발행할 수 있어요.</li>
          <li>학교·단체 구매 페이지에서 견적서와 서류를 먼저 받아볼 수 있어요.</li>
          <li>계좌이체로 결제하고 현금영수증을 받지 않은 사업자 결제는 angel@plactical.com으로 신청해주세요.</li>
        </ul>

        <h4>신청할 때 넣을 정보</h4>
        <ul>
          <li>왓퀴즈 가입 이메일, 결제일, 금액</li>
          <li>사업자등록번호(또는 고유번호), 상호, 대표자, 주소, 업태·종목</li>
          <li>담당자 연락처와 수신 이메일</li>
        </ul>
      </div>
    `,
    tags: ['세금계산서', '카드 매출전표', '현금영수증', '학교 예산', '교육기관', '전자세금계산서', '부가세'],
    relatedFaqs: ['payment-005', 'payment-001', 'payment-003'],
    lastUpdated: '2026-10-01',
    seoTitle: '왓퀴즈 세금계산서 발급 안내 - 카드 결제 증빙',
    seoDescription: '카드·현금영수증 결제는 세금계산서 중복 발행이 불가합니다. 행정실 제출용 영수증·거래명세서 받는 방법과 학교·단체 구매 세금계산서 안내.'
  },
  {
    id: 'payment-007',
    category: 'payment',
    question: '왓퀴즈 PRO 요금제는 어떻게 되나요?',
    answer: `
      <h4>왓퀴즈 PRO 요금</h4>
      <ul>
        <li><strong>1개월</strong>: 24,000원</li>
        <li><strong>3개월</strong>: 60,000원 (월 20,000원)</li>
        <li><strong>6개월</strong>: 110,000원 (월 18,333원)</li>
        <li><strong>12개월</strong>: 200,000원 (월 16,667원)</li>
      </ul>
      <p>부가세가 포함된 금액이에요. 기간이 길수록 월 환산 금액이 낮아져요. 할인 이벤트 기간에는 <a href="/pricing">요금제</a> 화면에 할인된 금액이 보여요.</p>

      <h4>PRO에서 쓰는 기능</h4>
      <ul>
        <li>GPT-6.1, Claude Sonnet 5.5, Gemini 3.1 Pro</li>
        <li>파일 첨부, 엑셀 일괄 처리, 디자인형 PPT·학습지</li>
        <li>참고 자료함 500개 (파일 포함)</li>
      </ul>
    `,
    tags: ['PRO', '요금제', '가격', '혜택', '플랜']
  },
  {
    id: 'payment-008',
    category: 'payment',
    question: '쿠폰은 어디에 등록하나요? 무료 체험도 있나요?',
    answer: `
      <p>쿠폰은 <a href="/subscription">마이페이지</a>의 <strong>쿠폰 등록</strong> 칸에 코드를 넣고 등록을 누르면 바로 PRO가 적용돼요.</p>
      <ol>
        <li>로그인한 뒤 오른쪽 위 내 이름 → 마이페이지로 가요</li>
        <li>쿠폰 등록 칸에 코드를 넣어요(대소문자 상관없어요)</li>
        <li>등록을 누르면 쿠폰에 적힌 기간만큼 PRO가 켜져요</li>
      </ol>
      <h4>잘 안 될 때</h4>
      <ul>
        <li>"이미 등록한 쿠폰"이라고 나오면 이미 적용된 거예요. 그대로 쓰면 돼요</li>
        <li>만료된 쿠폰이라고 나오면 마이페이지에서 7일 무료 체험을 시작할 수 있어요(계정당 1번, 카드 등록 없이)</li>
        <li>등록 후에도 FREE로 보이면 <a href="/support/faq/technical-004">PRO가 안 보일 때</a>를 확인해요</li>
      </ul>
    `,
    tags: ['쿠폰', '쿠폰 등록', '쿠폰 코드', '무료 체험', '7일 체험', '이용권 등록'],
    relatedFaqs: ['technical-004', 'payment-007', 'payment-003'],
    lastUpdated: '2026-10-15',
    seoTitle: '왓퀴즈 쿠폰 등록 방법과 7일 무료 체험',
    seoDescription: '마이페이지 쿠폰 등록 칸에 코드를 넣으면 PRO가 바로 적용돼요. 쿠폰이 만료됐다면 카드 없이 7일 무료 체험을 시작할 수 있어요.'
  }
];

// FAQ 검색 함수
export const searchPaymentFaq = (query) => {
  const searchTerm = query.toLowerCase();
  return paymentFaq.filter(faq => 
    faq.question.toLowerCase().includes(searchTerm) ||
    faq.answer.toLowerCase().includes(searchTerm) ||
    faq.tags.some(tag => tag.toLowerCase().includes(searchTerm))
  );
};

// ID로 FAQ 찾기
export const getPaymentFaqById = (id) => {
  return paymentFaq.find(faq => faq.id === id);
};

// 연관 FAQ 가져오기
export const getRelatedPaymentFaqs = (currentFaqId) => {
  const currentFaq = getPaymentFaqById(currentFaqId);
  if (!currentFaq || !currentFaq.relatedFaqs) return [];
  
  return currentFaq.relatedFaqs.map(id => getPaymentFaqById(id)).filter(Boolean);
};
